import React from 'react';
import { QueryProvider as FrameworkQueryProvider } from 'framework/context/QueryProvider';
import { documentsQuery_concurrencyToken, documentsQuery_query, IDocument, IDocumentsQueryParams, IQueryResult } from 'gen/ApiClient';
import { documentsQueryParamsLsKey } from '../../../localStorageKeys';
import { QueryContext } from './QueryContext';

const DefaultParams: IDocumentsQueryParams = {
	searchString: '',
	sortParams: { direction: 'desc', property: 'created' },
	pageParams: { index: 1, size: 10 },
	createdAfter: undefined,
	createdBefore: undefined,
	linkViewContextTypes: [],
	predefinedTypes: [],
};

export const QueryProvider = ({ children }: { children: any }) => {
	return (
		<FrameworkQueryProvider<IQueryResult<IDocument>, IDocumentsQueryParams>
			defaultParams={DefaultParams}
			queryF={documentsQuery_query}
			concurrencyF={documentsQuery_concurrencyToken}
			localStorageKey={documentsQueryParamsLsKey}
			context={QueryContext}>
			{children}
		</FrameworkQueryProvider>
	);
};
